/* eslint-disable import/order */
import Vue from 'vue'
import Vuex from 'vuex'
import config from '@/cms.config'
import { nuxtServerInit } from './nuxt-server-init'

Vue.use(Vuex)

const createStore = () => {
  return new Vuex.Store({
    ...config.store,
    actions: {
      nuxtServerInit,
      ...(config.store ? config.store.actions : {})
    }
  })
}

export default createStore
